import React, {  useState } from "react";
import { Button, Card, CardHeader, CardBody } from "reactstrap";
import DonorInformation from "./DonorInformation";
import DonationInformation from "./DonationInformation";

const DonationTracking = () => {
    const [activeDonationTab, setActiveDonationTab] = useState("donations");

    return (
        <Card>
            <CardHeader className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Donation Tracking</h3>
                <div>
                    <Button
                        color={activeDonationTab === "donors" ? "primary" : "secondary"}
                        size="sm"
                        onClick={() => setActiveDonationTab("donors")}
                    >
                        Donor Information
                    </Button>
                    <Button
                        color={activeDonationTab === "donations" ? "primary" : "secondary"}
                        size="sm"
                        onClick={() => setActiveDonationTab("donations")}
                    >
                        Donation Information
                    </Button>
                </div>
            </CardHeader>
            <CardBody>
                {activeDonationTab === "donors" && <DonorInformation />}
                {activeDonationTab === "donations" && <DonationInformation />}
            </CardBody>
        </Card>
    );
};

export default DonationTracking;